// "use strict";
import { OLabApiQuestion } from "./OLabApiQuestion";

export class OLabApiDragAndDropQuestion extends OLabApiQuestion {
  constructor(clientApi, id) {
    super(clientApi, id);
  }
}
